'use client';

import { useState } from 'react';
import HeroSection from './HeroSection';
import WorkflowVisualizer from './WorkflowVisualizer';
import ServicesGrid from './ServicesGrid';
import ROICalculator from './ROICalculator';
import CaseStudySpotlight from './CaseStudySpotlight';
import CTASection from './CTASection';
import ConsultationModal from './ConsultationModal';

const MarketingAutomationInteractive = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleScheduleConsultation = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <HeroSection onScheduleConsultation={handleScheduleConsultation} />
      <ServicesGrid />
      <WorkflowVisualizer />
      <ROICalculator />
      <CaseStudySpotlight />
      <CTASection onScheduleConsultation={handleScheduleConsultation} />
      <ConsultationModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default MarketingAutomationInteractive;